import React, { useCallback, useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import URL from "../../../../constants/url";
import HeadSub from '../../../../components/comm/HeadSub';
import style from './HospitalOrderSetting.module.css';
import {DndContext, closestCenter, PointerSensor, useSensor, useSensors,} from '@dnd-kit/core';
import {arrayMove, SortableContext, useSortable, verticalListSortingStrategy,} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

const SortableItem = ({ item, index }) => {

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: item.id,
    handle: true, // 드래그 핸들 지정
  });

  const styleItem = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 10 : 'auto',
    boxShadow: isDragging ? '0 4px 12px rgba(0, 0, 0, 0.15)' : 'none',
    background: '#fff', 
    width: '100%'
  };

  return (
    <li key={item.id} ref={setNodeRef} style={styleItem} className={isDragging ? style['dragging'] : ''}>
      <div className={style['inner-box']}>
        <div className={style['left']}>
          <div className={style['top-box']}>
            <p>{item.title}</p>
            <span className={`${style['status-s']} ${index === 0 ? style['show'] : ''}`} aria-hidden={`${index === 0 ? false : true}`} >대표 병원</span>
          </div>
          <span>내 환자 번호 {item.cnncPatntNo}</span>
        </div>
        <div className={style['right']}>
          <span
            className={style['hambuger-menu']}
            {...attributes}
            {...listeners}
            role="button"
            aria-label="병원 순서를 변경할 수 있는 드래그 버튼"
            aria-description="해당 아이콘을 끌어서 병원 노출 순서를 변경할 수 있습니다."
            aria-hidden="false"
          ></span>
        </div>
      </div>
    </li>
  );
};

const HospitalOrderSetting = () => {

  const navigate = useNavigate();

  const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

  const [items, setItems] = useState([]);

  useEffect(()=>{

    // usrHsptlMap을 items 형식으로 변환
    const transformed = loginUser.usrHsptlMap.map((entry, index) => ({
      hsptlSortOrdr: (index+1),
      id : entry.cnncHsptlCd,
      title : entry.cnncHsptlNm,
      usrInfoId : loginUser.usrInfoId,
      cnncHsptlCd: entry.cnncHsptlCd,
      cnncPatntNo: entry.cnncPatntNo,
    }));
    setItems(transformed);
  }, [])



  const saveHospitalOrderChange = useCallback(async (items) => {

    const url = "/hsptl/saveHsptlUsrMapInfo";
    const jToken = localStorage.getItem('jToken');

    const reqOptions = {
        headers: {
            Authorization: jToken,
        }
    }

    const reorderedItems = items.map((item, index) => ({
      ...item,
      hsptlSortOrdr: index + 1  // 순서는 1부터 시작
    }));
    
    await axiosApi.post(url, reorderedItems, reqOptions)
    .then((res) => {
        if (res.data.resultCode === CODE.RCV_SUCCESS) {

          // loginUser에 맞게 다시 설정
          const sortedHsptlMap = reorderedItems.map((item, index) => ({
            cnncHsptlCd : item.cnncHsptlCd,
            cnncHsptlNm : item.title,
            cnncPatntNo : item.cnncPatntNo,
            hsptlSortOrdr : item.hsptlSortOrdr,
            usrInfoId : item.usrInfoId
          }));
      
          loginUser.usrHsptlMap = sortedHsptlMap;

          // sessionStorage에 저장
          sessionStorage.setItem("loginUser", JSON.stringify(loginUser));
          
          navigate(URL.MY_HOSPITAL_SETTING, { state: { hsptlNm : reorderedItems[0].title, showModal: true } })
        } else {
          alert(res.data.resultMessage);
        }
    })
    .catch(err => {
        console.error("사용자의료건강정보 호출 중 오류  : ", err);
    })

}, []);
  
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        delay: 100,
        tolerance: 5,
      },
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {

      const oldIndex = items.findIndex((i) => i.id === active.id);
      const newIndex = items.findIndex((i) => i.id === over.id);
      setItems((items) => arrayMove(items, oldIndex, newIndex));

    }
  };

  return (
    <>
      <HeadSub title="병원 순서 변경" />

      <div id="sub-content" data-overflow="hidden">
        <div className="inner-wrap">
          <div className={style['content-box']}>
            <div className={style['order-list-box']}>

              <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                <SortableContext items={items.map((i) => i.id)} strategy={verticalListSortingStrategy}>
                  <ul className={style["touch-scroll-fix"]}>
                    {items.map((item, index) => (
                      <SortableItem key={item.id} item={item} index={index} />
                    ))}
                  </ul>
                </SortableContext>
              </DndContext>
              
            </div>

            <div className={style['list-box']}>
              <ul>
                <li>
                  <span>목록 우측 ≡ 아이콘을 끌어서 병원 노출 순서를 변경할 수 있습니다.</span>
                </li> 
                <li>
                  <span className={style['highlight']}>가장 상단에 위치한 병원은 대표 병원으로 설정 됩니다.</span>
                </li>
                <li>
                  <span>병원 노출 순서 변경 시 하기 화면에 적용됩니다.</span>
                  <ul>
                    <li>
                      <span>병원 케어 &gt; 변경된 순서대로 병원 탭 노출</span>
                    </li> 
                    <li>
                      <span>진료 카드 &gt; 변경된 순서대로 바코드 노출</span>
                      <p>
                        (단, 대표 병원으로 설정된 병원은 항상 첫번째로 노출되며 순서를 임의로 변경할 수 없습니다.)
                      </p>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
 
            <div className="bottom-fixed-box" data-border-line="top">
              <div className="inner-box">
                <div className="btn-layout" data-btn-num="2">
                  <button className="btn" data-btn-type="outline-main" data-btn-size="lg" onClick={() => navigate(-1)}>
                    <span>취소</span>
                  </button>
                  {/* <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={() => navigate(URL.MY_HOSPITAL_SETTING, { state: { showModal: true } })}> */}
                  <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={() => {

                    saveHospitalOrderChange(items);

                  }}>
                    <span>변경 완료</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HospitalOrderSetting;